import { render, staticRenderFns } from "./SearchModels.vue?vue&type=template&id=520baff2"
import script from "./SearchModels.vue?vue&type=script&lang=js"
export * from "./SearchModels.vue?vue&type=script&lang=js"
import style0 from "./SearchModels.vue?vue&type=style&index=0&id=520baff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports